module.exports = __webpack_public_path__ + "img/Lb.823bf2b6.png";